import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import "./CQStudentQuizTaker.css";
import Spinner from "../../Spinner/Spinner";
import { useStopwatch } from "react-timer-hook";
import { useBeforeunload } from "react-beforeunload";
import InnerHTML from "dangerously-set-html-content";
import CQStudentQuizResult from "./CQStudentQuizResult";
import loaderColors1 from "../../Spinner/loaderColors1.gif";
import {
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../app/util/HOC";
import QuizOptions from "./QuizOptions";
import ConfirmDialog from "./ConfirmDialog";
import { CHECKBOX, getQuestionStatus, MAX_SELECTION } from "./utils";
export default function CQStudentQuizTaker(props) {
  var cqStudQuizName = props.data.studQuizName,
    cqStudQuizId = props.data.studQuizId,
    cqClassSemId = props.data.studSemId,
    cqClassSemName = props.data.studSemName,
    cqClassProfName = props.data.studProfName,
    cqClassAsstName = props.data.studAsstname,
    cqClassName = props.data.studClassName,
    cqClassId = props.data.studClassId,
    cqStudQuizInstanceId = 0;
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const authToken = userVO.apJwtAuthenticationToken
    ? userVO.apJwtAuthenticationToken
    : localStorage.getItem("apJwtAuthenticationToken");
  const regexForStripHTML = /(<([^>]+)>)/gi;
  const cqStudQuizPopUpBtnsRef = useRef(null);
  const cqStudQuizSessionTimeOutPopUpNoBtnRef = useRef(null);
  const [classList, setClassList] = useState([]);
  const [isQuizLoading, setIsQuizloading] = useState(true);
  const [showQuizDetails, setShowQuizDetails] = useState(true);
  const [showQuestionList, setShowQuestionList] = useState(false);
  const [showQuizTakerPage, setShowQuizTakerPage] = useState(true);
  const [showQuizBackNotify, setShowQuizBackNotify] = useState(false);
  const [showQuizResultPage, setShowQuizResultPage] = useState(false);
  const [notificationTimeLeft, setNotificationTimeLeft] = useState(120); //2 mins in seconds
  const [studentLastActivity, setStudentLastActivity] = useState(Date.now());
  const [showTimeNotificationPopup, setShowTimeNotificationPopup] =
    useState(false);
  const quizSubmitDateTime = new Date()
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");
  const { seconds, minutes, hours, pause, start } = useStopwatch({
    autoStart: false,
  });
  const quizQuesAns = [];
  const [submitQuizPopUp, setSubmitQuizPopUp] = useState(false);
  const [quizQuests, setQuizQuests] = useState([]);
  const [totalQuests, setTotalQuests] = useState();
  const [currQuest, setCurrQuest] = useState();
  const [totalAnsQuests, setTotalAnsQuests] = useState();
  const [totalUnAnsQuests, setTotalUnAnsQuests] = useState();

  const [totalQuizTime, setTotalQuizTime] = useState();
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  useEffect(() => {
    if (showTimeNotificationPopup) {
      cqStudQuizSessionTimeOutPopUpNoBtnRef.current.focus();
    }
  }, [showTimeNotificationPopup]);
  const handleHidesessionOutMsg = () => {
    setShowTimeNotificationPopup(false);
  };
  useEffect(() => {
    if (submitQuizPopUp) {
      cqStudQuizPopUpBtnsRef.current.focus();
    }
  }, [submitQuizPopUp]);
  useEffect(() => {
    if (showQuizTakerPage) {
      const studentActivityListener = () => {
        setStudentLastActivity(Date.now());
        if (showTimeNotificationPopup && notificationTimeLeft === 0) {
          setShowTimeNotificationPopup(false);
          setNotificationTimeLeft(120);
        }
      };
      document.addEventListener("mousemove", studentActivityListener);
      document.addEventListener("keydown", studentActivityListener);
      const notifyTimer = setInterval(() => {
        const dateNow = Date.now();
        if (
          dateNow - studentLastActivity > 900000 &&
          !showTimeNotificationPopup
        ) {
          setShowTimeNotificationPopup(true);
          pause();
        }
      }, 60000); //1 min in milliseconds;
      return () => {
        clearTimeout(notifyTimer);
        document.removeEventListener("mousemove", studentActivityListener);
        document.removeEventListener("keydown", studentActivityListener);
      };
    }
  }, [showTimeNotificationPopup, studentLastActivity]);
  useEffect(() => {
    let notifyCountDownTimer;
    if (showTimeNotificationPopup) {
      notifyCountDownTimer = setInterval(() => {
        setNotificationTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
      }, 1000);
    }
    return () => clearInterval(notifyCountDownTimer);
  }, [showTimeNotificationPopup]);
  useEffect(() => {
    if (notificationTimeLeft === 0) {
      setShowTimeNotificationPopup(false);
      setShowQuizBackNotify(props.displayNotificationPopup);
      handleNavigateBack();
    }
  }, [notificationTimeLeft]);
  const handleHideContactMe = () => {
    setSubmitQuizPopUp(false);
  };
  const notificationTimeFormat = (timeLeft) => {
    const notifyTimeMins = Math.floor(timeLeft / 60);
    const notifyTimeSecs = timeLeft % 60;
    return `${notifyTimeMins < 10 ? "0" : ""}${notifyTimeMins}:${
      notifyTimeSecs < 10 ? "0" : ""
    }${notifyTimeSecs}`;
  };
  function fetchStudentCqDashboard(semId) {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          lastViewedCQSemesterId: semId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      cqSemesterVO: { semesterId: semId },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/quiz/api/getStudentCQDashboard`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          if (data.cqClassVOList) {
            var cqClassVOList = Array.isArray(data.cqClassVOList)
              ? data.cqClassVOList
              : [data.cqClassVOList];
            cqClassVOList.map((cqClass) => {
              if (cqClass.classQuizVOList) {
                cqClass.classQuizVOList = Array.isArray(cqClass.classQuizVOList)
                  ? cqClass.classQuizVOList
                  : [cqClass.classQuizVOList];
              }
            });
            setClassList(cqClassVOList);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchQuizData() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: cqClassId },
      quizDetails: { identifier: cqStudQuizId, answerMasked: true },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem(
        "qpAPI",
      )}/quiz/api/V2/quizDetailsWithQuestionList/${cqClassId}`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setQuizQuests(data.questions);
          setTotalQuests(data.questions.length);
          setCurrQuest(
            data.currentQuestion === 0
              ? data.currentQuestion + 1
              : data.currentQuestion,
          );
          setTotalAnsQuests(data.totalAnswered);
          setTotalUnAnsQuests(data.questions.length - data.totalAnswered);
          setTotalQuizTime(data.totalTimeSpent);
          if (data.questions.length > 0) {
            start();
          }
          setIsQuizloading(false);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchSaveForLater() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: cqClassId },
      quizDetails: {
        identifier: cqStudQuizId,
        currentQuestion: currQuest,
        totalAnswered: totalAnsQuests,
        questionIdentifiers: quizQuesAns,
        totalTimeSpent: totalQuizTime + convertHMSToSeconds(),
      },
    };
    const requestOptions = {
      method: "POST",
      keepalive: true,
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/quiz/api/V2/quiz-saveLater`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.text())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchSubmitQuiz() {
    cqStudQuizInstanceId =
      props.data.studQuizInstanceId === 0
        ? classList
            .filter(
              (cqClass) =>
                cqClass.semesterId === cqClassSemId &&
                cqClass.classId === cqClassId,
            )
            .map((filtClassList) => filtClassList.classQuizVOList)[0]
            .filter((cqClassQuiz) => cqClassQuiz.identifier === cqStudQuizId)
            .map((filtCQClassQuiz) => filtCQClassQuiz.instanceId)[0]
        : props.data.studQuizInstanceId;
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: cqClassId },
      quizDetails: {
        identifier: cqStudQuizId,
        totalAnswered: totalAnsQuests,
        numberOfQuestions: totalQuests,
        questionIdentifiers: quizQuesAns,
        completedDate: quizSubmitDateTime,
        instanceId: Number(cqStudQuizInstanceId),
        totalTimeSpent: totalQuizTime + convertHMSToSeconds(),
      },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/quiz/api/V2/Submit-Quiz`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.text())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (
          data === "Successfully Inserted Quiz Results" ||
          data === "The quiz is completed...!"
        ) {
          setShowQuizTakerPage(false);
          setShowQuizResultPage(true);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  useEffect(() => {
    document.title = `Quiz | ${cqStudQuizName} | ${cqClassName} | Connected Quizzing`;
    fetchQuizData();
    setTimeout(() => {
      fetchStudentCqDashboard(cqClassSemId);
    }, 3000);
  }, []);
  useBeforeunload(() => {
    handleSaveForLater();
  });
  function convertSecondsToHMS(value) {
    const sec = parseInt(value, 10);
    let hrs = Math.floor(sec / 3600);
    let mins = Math.floor((sec - hrs * 3600) / 60);
    let secs = sec - hrs * 3600 - mins * 60;
    if (mins < 10) {
      mins = "0" + mins;
    }
    if (secs < 10) {
      secs = "0" + secs;
    }
    return hrs + "h " + mins + "m " + secs + "s";
  }
  function convertHMSToSeconds() {
    return hours * 3600 + minutes * 60 + seconds;
  }
  // function handleSeleOption() {
  //   var count = 0;
  //   quizQuests.map((ques) => {
  //     if (ques.SelectedAnswerList.length !== 0) {
  //       count += 1;
  //     }
  //     return ques;
  //   });
  //   setTotalAnsQuests(count);
  //   setTotalUnAnsQuests(totalQuests - count);
  // }
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    text: "",
    buttons: [],
  });

  function navigateToQuestion(ques, nextQuestionNumber) {
    setCurrQuest(nextQuestionNumber);
    handlePrevNxtBtn();
  }

  const showDialog = (ques, nextQuestionNumber) => {
    setDialog({
      open: true,
      title: "Answer Incomplete",
      text: "You have selected only one response, and the instructions ask you to select two. Are you sure you want to move on? Select Cancel to return. Select OK to continue",
      buttons: [
        {
          label: "Cancel",
          action: () => setDialog((prev) => ({ ...prev, open: false })),
        },
        {
          label: "OK",
          action: () => [
            setDialog((prev) => ({ ...prev, open: false })),
            navigateToQuestion(ques, nextQuestionNumber),
          ],
        },
      ],
    });
  };
  function handleNavigation(ques, direction) {
    const nextQuestionNumber =
      direction === "next" ? currQuest + 1 : currQuest - 1;
    if (
      ques.itemTypeName === CHECKBOX &&
      ques.SelectedAnswerList.length > 0 &&
      ques.SelectedAnswerList.length < MAX_SELECTION
    ) {
      showDialog(ques, nextQuestionNumber);
    } else {
      setCurrQuest(nextQuestionNumber);
      handlePrevNxtBtn();
    }
  }
  const handleSelOption = () => {
    let answeredCount = 0;

    quizQuests.forEach((ques) => {
      const ans = ques.SelectedAnswerList;

      const isAnswered = Array.isArray(ans) && ans.length > 0;

      if (isAnswered) {
        answeredCount += 1;
      }
    });

    setTotalAnsQuests(answeredCount);
    setTotalUnAnsQuests(totalQuests - answeredCount);
  };

  function handleNextUnAnsw() {
    for (var i = 0; i < quizQuests.length; i++) {
      if (
        !Array.isArray(quizQuests[i].SelectedAnswerList) ||
        quizQuests[i].SelectedAnswerList.length === 0
      ) {
        setCurrQuest(quizQuests[i].ordinal_number);
        break;
      }
    }
  }
  function handleSaveResponses() {
    let eachQuesTime = 0,
      currQuesNo = 0,
      quesIndex = currQuest - 1;
    if (quizQuesAns.length === 0) {
      quizQuests.map((ques) => {
        if (quesIndex === currQuest - 1) {
          while (currQuesNo < totalQuests) {
            eachQuesTime += quizQuests[currQuesNo].timeSpent;
            currQuesNo += 1;
          }
          quizQuests[quesIndex].timeSpent += Math.abs(
            totalQuizTime + convertHMSToSeconds() - eachQuesTime,
          );
        }
        quesIndex += 1;
        let SelectedAnswerList = Array.isArray(ques.SelectedAnswerList)
          ? ques.SelectedAnswerList.filter((id) => id !== "")
          : [];
        if (
          ques.itemTypeName === "Multi Select Question" &&
          SelectedAnswerList.length === 0
        ) {
          SelectedAnswerList = [""];
          // SelectedAnswerList = ["", ""];
        } else if (
          ques.itemTypeName !== "Multi Select Question" &&
          SelectedAnswerList.length === 0
        ) {
          SelectedAnswerList = [];
        }
        var newSetQuizQues = {
          SelectedAnswerList,
          identifier: ques.question_identifier,
          timeSpent: ques.timeSpent,
        };
        quizQuesAns.push(newSetQuizQues);
        return ques;
      });
    }
  }
  function handleSaveForLater() {
    handleSaveResponses();
    fetchSaveForLater();
  }
  function handleNavigateBack() {
    setShowQuizTakerPage(false);
    setShowQuizDetails(props.displayQuiz);
    handleSaveForLater();
  }
  function handleSubmitQuiz() {
    setSubmitQuizPopUp(false);
    handleSaveResponses();
    fetchSubmitQuiz();
  }
  function handlePrevNxtBtn() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    handleSaveForLater();
  }
  const handleResume = () => {
    setTotalQuizTime(totalQuizTime + 900);
    setShowTimeNotificationPopup(false);
    setStudentLastActivity(Date.now());
    setNotificationTimeLeft(120);
    start();
  };
  return showQuizResultPage ? (
    <CQStudentQuizResult
      displayQuizResult={() => setShowQuizResultPage(false)}
      displayQuizTaker={() => setShowQuizDetails(props.displayQuiz)}
      data={props.data}
    />
  ) : showQuizTakerPage ? (
    <>
      <Spinner
        loading={isQuizLoading}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      <main>
        <div className="container">
          <div
            className="card cqStudQuizContainerSection"
            style={{ minHeight: "auto" }}
          >
            <div className="card-body cqStudQuizContainerCard">
              <div className="row">
                <div className=" col-xl-7 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div className="cqStudQuizLogoContainer col-xl-7 col-lg-8 col-md-10 col-sm-12 col-xs-12">
                    <img
                      className="cqStudQuizLogo"
                      src="/cc/images/CQ_logo_grey_screen.png"
                      alt="Connected Quizzing"
                    ></img>
                  </div>
                </div>
              </div>
              <div className="mt-2 cqStudQuizNameStyle">{cqStudQuizName}</div>
              <div className="mt-2 cqStudQuizDetailsStyle">
                <span>{cqClassSemName} </span> |
                <span> Professor {cqClassProfName}</span>
                {cqClassAsstName ? (
                  <span>
                    ,
                    {cqClassAsstName.map((cqClassStud, index) => {
                      return (
                        <span>
                          {cqClassStud.ccUserRole === "Student"
                            ? ` Assistant `
                            : ` Professor `}
                          {cqClassStud.lastName}
                          {index !== cqClassAsstName.length - 1 && ", "}
                        </span>
                      );
                    })}
                  </span>
                ) : null}{" "}
                |<span> Class: {cqClassName}</span>
              </div>
              {isQuizLoading === false ? (
                quizQuests && quizQuests.length === 0 ? (
                  <div
                    className="pb-2 mt-3"
                    style={{ textAlign: "center", fontFamily: "Fira Sans" }}
                  >
                    No Quiz Data Available
                  </div>
                ) : (
                  <>
                    <button
                      className="mt-3 cqStudQuizSaveBtn"
                      onClick={handleNavigateBack}
                    >
                      Save for Later
                    </button>
                    <div className="container">
                      <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-7 col-7 no-padding">
                          <button
                            type="button"
                            className="mt-2 cqStudQuizShowList"
                            onClick={() =>
                              setShowQuestionList(!showQuestionList)
                            }
                          >
                            {showQuestionList
                              ? `Hide Question List`
                              : `Show Question List`}
                          </button>
                          {showQuestionList ? (
                            <div className="cqStudQuizQuestions pl-3 mr-4">
                              {totalUnAnsQuests === 0 ? (
                                <div className="py-3"></div>
                              ) : (
                                <>
                                  <button
                                    type="button"
                                    className="cqStudQuizNext py-3"
                                    onClick={handleNextUnAnsw}
                                  >
                                    Next Unanswered
                                  </button>
                                </>
                              )}
                              {quizQuests.map((ques) => {
                                //Partially Answered logic below
                                const status = getQuestionStatus(ques);

                                return (
                                  <button
                                    type="button"
                                    aria-pressed={
                                      ques.ordinal_number === currQuest
                                        ? true
                                        : false
                                    }
                                    className={
                                      status === "Unanswered"
                                        ? "cqStudQuizQuestionUn pb-2"
                                        : "cqStudQuizQuestion pb-2"
                                    }
                                    style={
                                      ques.ordinal_number === currQuest
                                        ? { background: "#DADADA" }
                                        : null
                                    }
                                    onClick={(event) => {
                                      setCurrQuest(ques.ordinal_number);
                                    }}
                                  >
                                    {ques.ordinal_number}: {status}
                                  </button>
                                );
                              })}
                            </div>
                          ) : null}
                        </div>
                        <div
                          className={
                            showQuestionList
                              ? "cqStudQuizQuestionsExpandStyle col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 no-padding"
                              : "cqStudQuizQuestionsCollapseStyle col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"
                          }
                        >
                          <div className="row">
                            <div
                              role="status"
                              className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 pb-2"
                            >
                              <span className="cqStudQuizQuestionStatus">
                                Question:
                              </span>
                              <br></br>
                              <span className="cqStudQuizQuestionDetail">
                                {currQuest} of {totalQuests}
                              </span>
                            </div>

                            <div
                              role="status"
                              className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 pr-0"
                            >
                              <span className="cqStudQuizQuestionStatus">
                                Unanswered:
                              </span>
                              <br></br>
                              <span className="cqStudQuizQuestionDetail">
                                {totalUnAnsQuests} of {totalQuests}
                              </span>
                            </div>
                            <div
                              role="timer"
                              className="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-6"
                            >
                              <span className="cqStudQuizQuestionStatus">
                                Time Spent:
                              </span>
                              <br></br>
                              <span className="cqStudQuizQuestionDetail">
                                {convertSecondsToHMS(
                                  convertHMSToSeconds() + totalQuizTime,
                                )}
                              </span>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 p-0">
                              <button
                                className="btn cqStudQuizSubmitBtn ml-xl-3 ml-lg-3 ml-md-2 ml-3"
                                onClick={() => [
                                  pause(),
                                  setSubmitQuizPopUp(true),
                                ]}
                              >
                                Submit Quiz
                              </button>
                            </div>
                          </div>
                          <hr></hr>
                          <div className="row">
                            {quizQuests.map((ques) => {
                              return ques.ordinal_number === currQuest ? (
                                <React.Fragment key={ques.question_identifier}>
                                  <fieldset className="p-0 m-0 border-0">
                                    {/* Question */}
                                    <legend className="p-0 m-0">
                                      <div
                                        id={ques.question_identifier}
                                        className="cqStudQuizQuestionDesc col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                      >
                                        <InnerHTML html={ques.promptText} />
                                      </div>
                                    </legend>
                                    {/* Quiz Options*/}
                                    <QuizOptions
                                      ques={ques}
                                      regexForStripHTML={regexForStripHTML}
                                      handleSelOption={handleSelOption}
                                    />
                                  </fieldset>
                                  <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4 pr-0">
                                    <div
                                      className={
                                        showQuestionList
                                          ? "col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 mt-4 pr-0"
                                          : "col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mt-4"
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn cqStudQuizOtherBtn cqStudQuizOther3BtnWidth"
                                        onClick={() => {
                                          setQuizQuests((prev) =>
                                            prev.map((q) =>
                                              q.question_identifier ===
                                              ques.question_identifier
                                                ? {
                                                    ...q,
                                                    SelectedAnswerList: [],
                                                  }
                                                : q,
                                            ),
                                          );
                                          handleSelOption();
                                          document
                                            .getElementById(
                                              ques.choiceInteration
                                                .simpleChoices[0].externalId,
                                            )
                                            ?.focus();
                                        }}
                                        disabled={
                                          ques.SelectedAnswerList.filter(
                                            (id) => id !== "",
                                          )?.length === 0
                                        }
                                      >
                                        Clear Response
                                      </button>
                                    </div>
                                    <div
                                      className={
                                        showQuestionList
                                          ? "col-xl-9 col-lg-8 col-md-8 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 pr-md-0 pl-xl-0 pl-lg-0 pl-md-0 pl-sm-0 pl-3 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                          : "col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 pr-md-0 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                      }
                                    >
                                      <div className="d-inline-flex cqStudQuizOtherBtnBlockFullWidth">
                                        <button
                                          type="button"
                                          className="btn cqStudQuizOtherBtn mr-xl-2 mr-lg-2 mr-md-2 mr-sm-2 mr-0"
                                          // onClick={() => [
                                          //   setCurrQuest(currQuest - 1),
                                          //   handlePrevNxtBtn(),
                                          // ]}
                                          onClick={() =>
                                            handleNavigation(ques, "previous")
                                          }
                                          disabled={
                                            currQuest === 1 ? true : false
                                          }
                                        >
                                          Previous Question
                                        </button>
                                      </div>
                                      <div className="cqStudQuizOtherBtnBlockMargin d-inline-flex ml-xl-4 ml-lg-4 ml-md-4 ml-sm-4 ml-2">
                                        <button
                                          type="button"
                                          className="btn cqStudQuizOtherBtn"
                                          // onClick={() => [
                                          //   setCurrQuest(currQuest + 1),
                                          //   handlePrevNxtBtn(),
                                          // ]}
                                          onClick={() =>
                                            handleNavigation(ques, "next")
                                          }
                                          disabled={
                                            currQuest === totalQuests
                                              ? true
                                              : false
                                          }
                                        >
                                          Next Question
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="cqStudQuizQuestionID row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4">
                                    ID: {ques.question_identifier}
                                  </div>
                                </React.Fragment>
                              ) : null;
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )
              ) : null}
            </div>
          </div>
          <ConfirmDialog
            open={dialog.open}
            title={dialog.title}
            text={dialog.text}
            buttons={dialog.buttons}
            onClose={() => setDialog((prev) => ({ ...prev, open: false }))}
          />
          <Modal
            className="modal fade"
            show={submitQuizPopUp}
            onHide={() => handleHideContactMe()}
            role="dialog"
            size="sm"
            aria-labelledby="contained-modal-title-unanswered2"
            centered
          >
            <div
              className="cqStudQuizPopUpHeader mt-4 mb-2"
              style={{ textAlign: "center" }}
            >
              <div
                aria-hidden="true"
                className="fa fa-exclamation-circle"
                style={
                  totalUnAnsQuests === 0
                    ? { fontSize: "30px", color: "grey" }
                    : { fontSize: "30px", color: "red" }
                }
              ></div>
            </div>
            <div
              aria-label={
                totalUnAnsQuests === 0
                  ? "Quiz submission confirmation"
                  : "Incomplete quiz submission confirmation"
              }
              id="contained-modal-title-unanswered2"
              className="cqStudQuizPopUpBody mx-4"
            >
              {totalUnAnsQuests === 0 ? null : (
                <p className="cqStudQuizPopUpTxt" style={{ color: "#E61700" }}>
                  You have {totalUnAnsQuests}{" "}
                  {totalUnAnsQuests > 1 ? `questions` : `question`} unanswered.
                </p>
              )}
              <p className="cqStudQuizPopUpTxt">
                You will not be able to return to the quiz after submitting. Are
                you ready to submit your quiz?
              </p>
            </div>
            <div className="cqStudQuizPopUpFooter">
              <button
                className="cqStudQuizPopUpBtns mr-2"
                onClick={() => [start(), setSubmitQuizPopUp(false)]}
              >
                No, Go Back
              </button>
              <button
                ref={cqStudQuizPopUpBtnsRef}
                className="cqStudQuizPopUpBtns"
                onClick={handleSubmitQuiz}
              >
                Yes, Submit
              </button>
            </div>
          </Modal>
          <Modal
            className="modal fade"
            show={showTimeNotificationPopup}
            onHide={() => handleHidesessionOutMsg()}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName="border border-dark"
          >
            <div className="cqStudQuizSessionTimeOutPopUpHeader mt-4 mx-4">
              <p className="cqStudQuizSessionTimeOutPopUpHeadTxt">
                Your session is about to expire due to inactivity in 00:
                {notificationTimeFormat(notificationTimeLeft)}
              </p>
            </div>
            <div className="cqStudQuizSessionTimeOutPopUpBody mx-4">
              <p className="cqStudQuizSessionTimeOutPopUpBodyTxt mb-3">
                Your responses will be saved after the time-out.
              </p>
              <p className="cqStudQuizSessionTimeOutPopUpBodyTxt m-0 mb-4">
                {" "}
                Do you want to resume the quiz?{" "}
              </p>
            </div>
            <div className="cqStudQuizSessionTimeOutPopUpFooter">
              <button
                ref={cqStudQuizSessionTimeOutPopUpNoBtnRef}
                className="cqStudQuizSessionTimeOutPopUpNoBtn mr-2"
                onClick={handleNavigateBack}
              >
                No, Save For Later
              </button>
              <button
                className="cqStudQuizSessionTimeOutPopUpYesBtn"
                onClick={handleResume}
              >
                Yes, Resume
              </button>
            </div>
          </Modal>
        </div>
      </main>
    </>
  ) : null;
}
